export default {"src":"/_next/static/media/gift.76b05125.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};